import React, { Component } from "react";

import { Camera, encodeBase64 } from "utils";

export default class extends Component {
  onCapture = async data => {
    const image = await encodeBase64(data);
    this.props.onCapture(image);
  };
  render = () => {
    return <Camera onCapture={this.onCapture}>{this.props.children}</Camera>;
  };
}
